import { render, staticRenderFns } from "./SubmitalLockModal.vue?vue&type=template&id=2f5c237d&scoped=true&"
import script from "./SubmitalLockModal.vue?vue&type=script&lang=js&"
export * from "./SubmitalLockModal.vue?vue&type=script&lang=js&"
import style0 from "./SubmitalLockModal.vue?vue&type=style&index=0&id=2f5c237d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5c237d",
  null
  
)

export default component.exports